
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter as ObiFilterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter.js';
 
 
 

 
 export const ObiFilter = createComponent({
   react: React,
   tagName: 'obi-filter',
   elementClass: ObiFilterElement,
   events: {
     
   }
  });
 
 